export default __webpack_public_path__ + "static/media/large-backdrop.7dd81844.png";